import { http, createConfig } from "wagmi";
import { chains, wagmiChains } from "./chains.js";
import {
  anchorageDigitalWallet,
  backpackWallet,
  bitgetWallet,
  braveWallet,
  coinbaseWallet,
  coreWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  phantomWallet,
  rabbyWallet,
  rainbowWallet,
  trustWallet,
  uniswapWallet,
  walletConnectWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";

const projectId =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ||
  import.meta.env.VITE_PROJECT_ID ||
  "YOUR_PROJECT_ID";

const projectName = "Web3 DApp"; // fleet fork — e.g. deBridge, Aerodrome, etc.

const connectors = connectorsForWallets(
  [
    {
      groupName: "Popular",
      wallets: [
        anchorageDigitalWallet,
        metaMaskWallet,
        rabbyWallet,
        phantomWallet,
        bitgetWallet,
        okxWallet,
        injectedWallet,
        coinbaseWallet,
        walletConnectWallet,
        trustWallet,
        backpackWallet,
        coreWallet,
        braveWallet,
        zerionWallet,
        rainbowWallet,
        uniswapWallet,
      ],
    },
  ],
  { appName: projectName, projectId },
);

const transports = Object.fromEntries(
  wagmiChains
    .filter((c) => chains[c.id]?.rpcUrl)
    .map((c) => [c.id, http(chains[c.id].rpcUrl)]),
);

const config = createConfig({
  chains: wagmiChains,
  transports,
  connectors,
});

export default config;

export const defaultChainId = 1;

export const prefChainIds = wagmiChains.map((c) => c.id);
